import './Footer.scss'
import React from 'react'
import dayjs from 'dayjs'
import { selectDomain, selectResellerConfig, selectSettings, selectSymbol } from 'features/app/settings/settingsSlice'
import { useSelector } from 'react-redux'
import classNames from 'classnames'
import DetailedFooter from './DetailedFooter/DetailedFooter'
import { useTranslation } from 'react-i18next'

export interface FooterProps {
	social?: boolean
	alignLeft?: boolean
	detailed?: boolean
}

const Footer: React.FC<FooterProps> = ({
	alignLeft = false,
	detailed = false
}) => {
	const { t } = useTranslation()
	const domain = useSelector(selectDomain)
	const symbol = useSelector(selectSymbol)
	const resellerConfig = useSelector(selectResellerConfig)
	const settings = useSelector(selectSettings)
	const additionalMenuItems = settings?.additionalMenuItems.filter(item => item.showInFooter) || []

	return (
		<footer className={classNames('Footer', { 'alignLeft': alignLeft })}>
			{detailed &&
				<DetailedFooter />
			}

			<div className="footer-wrapper">
				<small>
					{domain && (
						<span>
							{domain.charAt(0).toUpperCase() + domain.slice(1)}
							<span className="text-spacer"> - </span>
						</span>
					)}

					{symbol && (
						<span>
							{symbol}
							<span className="text-spacer"> - </span>
						</span>
					)}

					{dayjs().year()}
					<span className="text-spacer"> - </span>
					{
						resellerConfig ?
							<span>{settings?.title}</span> :
							<a href="https://nordictyregroup.com/">Nordic Tyre Group</a>
					}
					{Boolean(settings?.pageConfig?.privacyPolicy) &&
						<span>
							<span className="text-spacer"> - </span>
							<a href="/policy">{t('common.privacyPolicy')}</a>
						</span>
					}
					{
						additionalMenuItems.map((item) => {
							return (
								<span key={item.title}>
									<span className="text-spacer"> - </span>
									<a href={item.link}>{t('extraPage.' + item.translation)}</a>
								</span>
							)
						})
					}
				</small>
			</div>
		</footer>
	)
}

export default Footer